import Pusher from 'pusher-js';
import store from '../store';
if(process.env.NODE_ENV != "production"){
	//Pusher.logToConsole = true;
}
export default {
	instance: null,
	getInstance(){
		if(this.instance !== null){//singleton
			return this.instance;
			
		}
		this.instance = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
				cluster: 'us3',
				authEndpoint:process.env.VUE_APP_API_URL+'/broadcasting/auth',
				auth: {
					headers: {
						'accept': "application/json",
						'authorization': "Bearer "+store.state.currentToken??''
					},
				}
			});
		return this.instance;
	}
}